lmApp.service('GeoIPRules', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/geoip-rules',
    null,
    {
      get: {
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        },
        isArray: true,
        transformResponse: function (data) {
            var result = angular.fromJson(data);
            return (result.data || [])
        }
      },
      create: {
        method: 'POST',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        url: '/discovery:80/sdp/v2/geoip-rules/:id',
        method: 'PATCH',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      remove: {
        url: '/discovery:80/sdp/v2/geoip-rules/:id',
        method: 'DELETE',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      }
    });
}]);
